var _rect, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-5 -5 27 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Flag of Uruguay") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: -5,
    width: 27,
    height: 18,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0038a8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: -3,
    width: 17,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 1,
    width: 17,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: 5,
    width: 27,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: 9,
    width: 27,
    height: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.11)",
    fill: "#fcd116",
    stroke: "#000",
    strokeWidth: 0.6,
    strokeMiterlimit: 20
  }, /*#__PURE__*/React.createElement("g", {
    id: "u"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(22.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.5,9 6,12 C -2,25 7,27 0,33 3,26 -3,28 -3,16",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0,11 C -2,24 4.5,28 0,33",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 h 6 l -6,33 l -6,-33 h 6 v 33"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "rotate(45)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    transform: "rotate(90)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    transform: "rotate(180)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 11
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "right"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 81,-44 c -7,8 -11,-6 -36,-6 -25,0 -29,15 -33,12 -4,-3 21,-21 29,-22 8,-1 31,7 40,16 M 52,-35 c 7,6 1,19 -6,19 -7,0 -20,-12 -14,-20"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 19,-26 c 1,-12 11,-14 27,-14 16,0 23,12 29,15 -7,0 -13,-10 -29,-10 -16,0 -16,0 -27,10 M 22,-23 c 4,-6 9,6 20,6 11,0 17,-3 24,-8 7,-5 -10,12 -21,12 -11,0 -26,-6 -23,-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 56,-17 c 13,-7 5,-17 0,-19 2,2 10,12 0,19 M 0,43 c 6,0 8,-2 16,-2 8,0 27,11 38,7 -23,9 -14,3 -54,3 h -5 M 58,57 c -4,-7 -3,-5 -11,-16 8,6 10,9 11,16 M 0,67 C 25,67 21,62 54,48 30,51 25,59 0,59 h -5 M 0,30 c 7,0 9,-5 17,-5 8,0 19,3 24,7 1,1 -3,-8 -11,-9 C 22,22 25,9 16,7 c 0,4 3,3 4,9 0,5 -9,5 -11,0 2,8 -4,8 -9,8"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#right",
    transform: "scale(-1,1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0,76 c -5,0 -18,3 0,3 18,0 5,-3 0,-3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUy);
export default __webpack_public_path__ + "static/media/uy.8d4599121ab86f62d1fae6a1a4b29ac9.svg";
export { ForwardRef as ReactComponent };